import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ConsultoriaCompletaPage = lazy(() => import('../pages/consultoria/page'));
const LinksPage = lazy(() => import('../pages/links/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/consultoriacompleta',
    element: <ConsultoriaCompletaPage />,
  },
  {
    path: '/links',
    element: <LinksPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
